var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{staticClass:"code-block rounded code code-syntax-highlight-theme",style:(_vm.styleObject)},[_vm._t("default",function(){return [_c('code',{staticClass:"gl-block"},[_vm._v(_vm._s(_vm.code))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }